import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import GenericAccordion from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// PortableComponent.cshtml dispatches via `content.Content.GetType().Name`,
// which yields the CLR class name "GenericAccordion".
global.GenericAccordion = GenericAccordion;
